<template>
  <custom-dialog width="1300px" class="protocol-topic-item-dialog" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" ref="body">
      <div class="content">
        <el-form class="form" ref="form" :rules="rules" :model="form">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item :label="$t('dms_topic_item_dialog.Topiclei_bie')" prop="topicClass">
                <custom-select v-model="form.topicClass" code="iot_topic_class" width="100%"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_topic_item_dialog.Topiclei_xing')" prop="topicType">
                <custom-select v-model="form.topicType" code="iot_topic_type" width="100%"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item :label="$t('dms_topic_item_dialog.Topicming_cheng')" prop="topicName">
                <el-input v-model="form.topicName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_topic_item_dialog.TopicNamedyybm')" prop="langTopicName">
                <el-input v-model="form.langTopicName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.Topicbian_ma')" prop="topicCode">
                <el-input v-model="form.topicCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.xie_yi_bian_ma')" prop="tcpTopicCode">
                <el-input v-model="form.tcpTopicCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.suo_shu_ye_wu')">
                <custom-select v-model="form.topicBizCode" code="iot_topic_biz_code"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="Topic URL" prop="topicUrl">
                <el-input v-model="form.topicUrl"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('dms_topic_item_dialog.xia_fa_mo_ni_ji')">
                <el-radio v-model="form.isVirtualTopic" :label="1">{{ getDicValue('isynergy_cloud_bool', '1') }}</el-radio>
                <el-radio v-model="form.isVirtualTopic" :label="0">{{ getDicValue('isynergy_cloud_bool', '0') }}</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item :label="$t('dms_topic_item_dialog.Topicmiao_shu')" prop="topicDesc">
                <el-input type="text" v-model="form.topicDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.yun_xu_xia_fa_ji_qi')">
                <custom-select v-model="form.controlMode" code="iot_topic_control_mode"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.xian_shi_shun_xu')" prop="showOrder">
                <el-input type="number" v-model.number="form.showOrder" :min="0"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('Common.com_status')" prop="state">
                <custom-select v-model="form.state" code="cloud_common_state" width="100%"></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.shang_chuan_lei_xing')">
                <custom-select v-model="form.uploadType" code="iot_topic_upload_type"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.scjgm')">
                <el-input v-model="form.uploadInterval" :min="0" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.ccsct')">
                <el-input v-model="form.storageDuration" :min="0" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="15">
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.chao_shi_ce_lve')">
                <custom-select v-model="form.timeoutStrategy" code="iot_tsl_timeout_strategy"></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.csddm')">
                <el-input v-model="form.timeoutWait" :min="0" type="number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.cscscs')">
                <el-input v-model="form.timeoutRetryCount" :min="0" type="number"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <el-form-item :label="$t('dms_topic_item_dialog.ming_ling_mo_shi')">
                <custom-select v-model="form.commandMode" code="topic_command_mode"></custom-select>
              </el-form-item>
            </el-col>
            <template v-if="dicMap.topic_command_mode && form.commandMode === dicMap.topic_command_mode.service_status_change">
              <el-col :span="8">
                <el-form-item :label="$t('dms_topic_item_dialog.mlztlx')">
                  <custom-select v-model="form.commandStatusType" code="command_status_type"></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('dms_topic_item_dialog.mlztzdx')">
                  <el-input v-model="form.commandStatusDicGroup"></el-input>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </el-form>
        <div class="relation-content">
          <div class="header">
            <div class="title">{{ $t('dms_topic_item_dialog.sjccsz') }}</div>
          </div>
          <div class="table-bd">
            <custom-table
              :max-height="500"
              :column="tableColumn"
              :data="tableList"
              @filter="filterChange"
              @sort="sortChange"
              :slots="['saveMode', 'saveType', 'dbType', 'saveDb', 'saveDbTable', 'showOrder']"
            >
              <template v-slot:saveMode="scope">
                <custom-select v-model="scope.row.saveMode" code="iot_topic_save_mode" width="100%" value-type="number"></custom-select>
              </template>
              <template v-slot:saveType="scope">
                <custom-select v-model="scope.row.saveType" code="iot_topic_db_opt_type" width="100%" value-type="number"></custom-select>
              </template>
              <template v-slot:dbType="scope">
                <custom-select v-model="scope.row.dbType" code="iot_topic_db_type" width="100%" :placeholder="scope.$index > 0 ? $t('dms_topic_item_dialog.tong_shang') : ''"></custom-select>
              </template>
              <template v-slot:saveDb="scope">
                <el-input v-model="scope.row.saveDb" :placeholder="scope.$index > 0 ? $t('dms_topic_item_dialog.tong_shang') : ''"></el-input>
              </template>
              <template v-slot:saveDbTable="scope">
                <el-input v-model="scope.row.saveDbTable"></el-input>
              </template>
              <template v-slot:showOrder="scope">
                <el-input v-model="scope.row.showOrder" type="number" :min="0"></el-input>
              </template>
              <el-table-column :label="$t('Common.com_handle')">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="delRelation(scope.$index)">{{ $t('Common.com_delete') }}</el-button>
                </template>
              </el-table-column>
            </custom-table>
          </div>
          <div size="big" class="add-row" type="primary" @click="addData">
            <i class="el-icon-plus el-icon--left"></i>
            {{ $t('Common.com_added') }}
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    // add:新增 edit:编辑
    type: {
      type: String,
      default: 'add',
    },
    topicId: String,
    protocolCode: String,
  },
  data() {
    return {
      tableCode: 'topic_data_relation',
      visible: true,
      form: {
        // Topic类别   字典 iot_topic_class
        topicClass: '',
        // Topic编码
        topicCode: '',
        // TopicURL
        topicUrl: '',
        // 协议代码
        tcpTopicCode: '',
        // Topic操作权限   字典 iot_topic_type
        topicType: '',
        // 显示排序
        showOrder: '',
        // 状态   字典 cloud_common_state
        state: '1',
        // Topic描述
        topicDesc: '',
        topicName: '',
        langTopicName: '',
        // 允许下发机器 topic_control_mode
        controlMode: '',
        // 命令模式 topic_command_mode
        commandMode: '',
        // 命令状态类型 command_status_type
        commandStatusType: '',
        // 命令状态字典项
        commandStatusDicGroup: '',
        // 所属业务
        topicBizCode: '',
        // 状态上传类型 uploadType iot_topic_upload_type
        uploadType: '',
        // 上传间隔（分） uploadInterval
        uploadInterval: '',
        // 存储时长（天）storageDuration
        storageDuration: '',
        // 超时策略 timeoutStrategy iot_tsl_timeout_strategy
        timeoutStrategy: '',
        // 超时等待（秒）timeoutWait
        timeoutWait: '',
        // 超时重试次数  timeoutRetryCount
        timeoutRetryCount: '',
        // 下发模拟机
        isVirtualTopic: 0,
      },
      tableList: [],
      recordList: [],
      fullKeyArr: ['saveMode', 'saveType', 'dbType', 'saveDb', 'saveDbTable', 'showOrder'],
      checkKeyArr: ['saveMode', 'saveType', 'dbType', 'saveDb'],
    };
  },
  mounted() {
    this.getTableColumn();
    this.init();
    this.getDbList();
  },

  computed: {
    rules() {
      return {
        // Topic类别 必选
        topicClass: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // Topic编码 必填 30
        topicCode: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
        ],
        // TopicURL 必填 100
        topicUrl: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 100,
            message: this.$t('Common.com_rules_length_max', [100]),
          },
        ],
        // 协议代码 30
        tcpTopicCode: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
        ],
        // Topic操作权限 必选
        topicType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        // Topic描述 选填 200
        topicDesc: {
          max: 200,
          message: this.$t('Common.com_rules_length_max', [200]),
        },
        topicName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        langTopicName: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    getCheckList() {
      // 过滤掉空行
      const list = this.tableList.filter((item) => item.saveMode || item.saveType || item.dbType || item.saveDb || item.saveDbTable);
      const arr = this.$formatCopyUp(list, ['dbType', 'saveDb']);
      return arr.filter((item) => {
        const vals = this.checkKeyArr.map((key) => item[key]);
        return vals.some((val) => val);
      });
    },
    fixBody() {
      setTimeout(() => {
        this.$refs.body.scrollTop = 0;
      }, 100);
    },
    closeDialog() {
      this.visible = false;
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.checkRelation((validate) => {
            if (validate) {
              if (this.model.type === 'add') {
                this.create();
              } else {
                this.edit();
              }
            }
          });
        }
      });
    },
    init() {
      this.getDicMap('iot_topic_control_mode,topic_command_mode', () => {
        this.initData();
      });

      this.fixBody();
    },
    getDbList() {
      if (this.model.type === 'add') {
        this.tableList = this.fixDbList([]);
      } else {
        this.$getJSON(apis.TopicDbList, { topicId: this.topicId }).then((res) => {
          this.tableList = this.fixDbList(res.data);
        });
      }
    },
    initData() {
      if (this.model.type === 'edit') {
        const {
          topicClass,
          topicCode,
          topicUrl,
          tcpTopicCode,
          topicType,
          showOrder,
          state = '1',
          topicDesc,
          topicName,
          controlMode = '',
          commandMode = '',
          commandStatusType = '',
          commandStatusDicGroup,
          topicBizCode = '',
          uploadType,
          uploadInterval,
          storageDuration,
          timeoutStrategy,
          timeoutWait,
          timeoutRetryCount,
          isVirtualTopic = 0,
          langTopicName = '',
        } = this.model.data;
        this.form = {
          topicClass: String(topicClass),
          topicCode,
          topicUrl,
          tcpTopicCode,
          topicType: String(topicType),
          showOrder,
          state: String(state),
          topicDesc,
          topicName,
          controlMode: String(controlMode),
          commandMode: String(commandMode),
          commandStatusType: String(commandStatusType),
          commandStatusDicGroup,
          topicBizCode,
          uploadType,
          uploadInterval,
          storageDuration,
          timeoutStrategy,
          timeoutWait,
          timeoutRetryCount,
          isVirtualTopic,
          langTopicName,
        };
      }
      if (!this.form.controlMode) {
        this.form.controlMode = this.dicMap.iot_topic_control_mode.many;
      }
    },
    addData() {
      const row = {
        saveMode: '',
        saveType: '',
        dbType: '',
        saveDb: '',
        saveDbTable: '',
        showOrder: 0,
      };
      this.tableList.push(row);
    },
    fixDbList(list) {
      if (list.length >= 3) {
        return list;
      }
      const fixLen = 3 - list.length;
      const fixArr = [];
      for (let i = 0; i < fixLen; i++) {
        fixArr.push({
          saveMode: '',
          saveType: '',
          dbType: '',
          saveDb: '',
          saveDbTable: '',
          showOrder: 1,
        });
      }
      return [...list, ...fixArr];
    },
    create() {
      this.$postJSON(apis.TopicSave, this.getCreateReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', 'add');
      });
    },
    edit() {
      this.$postJSON(apis.TopicSave, this.getEditReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.closeDialog();
        this.$emit('success', 'add');
      });
    },
    getCreateReqData() {
      const ret = {
        ...this.form,
        dbList: this.getCheckList(),
        protocolCode: this.protocolCode,
      };
      // 此两项命令模式是服务.状态更改时显示
      if (this.form.commandMode !== this.dicMap.topic_command_mode.service_status_change) {
        this.form.commandStatusType = '';
        this.form.commandStatusDicGroup = '';
      }
      return ret;
    },
    getEditReqData() {
      return {
        ...this.getCreateReqData(),
        topicId: this.model.data.topicId,
      };
    },
    checkRelation(cb) {
      cb = cb || function () {};
      const checkList = this.getCheckList();

      if (checkList.some((item) => !item.saveMode)) {
        const tips = this.$t('dms_topic_item_dialog.ccmsbnwk');
        this.$message.error(tips);
        return cb(false);
      }
      if (checkList.some((item) => !item.saveType)) {
        const tips = this.$t('dms_topic_item_dialog.bclxbnwk');
        this.$message.error(tips);
        return cb(false);
      }
      if (checkList.some((item) => !item.dbType)) {
        const tips = this.$t('dms_topic_item_dialog.sjklxbnwk');
        this.$message.error(tips);
        return cb(false);
      }
      if (checkList.some((item) => !item.saveDb)) {
        const tips = this.$t('dms_topic_item_dialog.sjkbnwkzfcdzc30gzf');
        this.$message.error(tips);
        return cb(false);
      }
      return cb(true);
    },
    delRelation(index) {
      this.tableList.splice(index, 1);
      // this.delRecord(index);
    },
  },
};
</script>

<style lang="scss">
.protocol-topic-item-dialog {
  .dialog-body {
    .content {
      display: flex;

      .form {
        width: 500px;
        padding-right: 15px;
      }
      .relation-content {
        flex: 1;
        border-left: 1px solid #ccc;
        padding-left: 15px;

        .header {
          overflow: hidden;
          .title {
            float: left;
            line-height: 28px;
            padding-right: 20px;
            font-weight: bold;
            color: #2c405e;
          }
        }
      }

      .add-row {
        margin-top: 16px;
        width: 100%;
        background: #f5f5f7;
        border: 1px #e4e4e4 dashed;
        height: 40px;
        line-height: 38px;
        text-align: center;
        font-size: 12px;
        color: #495057;
        &:hover {
          cursor: pointer;
        }

        .el-icon-plus {
          color: #0d9ae0;
          font-weight: bold;
        }
      }
    }
  }
  .el-form-item {
    margin-bottom: 20px !important;
  }
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }
  .el-select {
    width: 100%;
  }
  .el-textarea__inner {
    height: 63px !important;
  }
}
</style>
